import React from "react";
import { useAnimation as UseAnimation, motion } from "framer-motion";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

import Image from "next/image";
import Link from "next/link";

import Sa01 from "@/public/static/images/sa-01.png";
import Sa02 from "@/public/static/images/sa-02.png";
import Sa03 from "@/public/static/images/sa-03.png";
import Sa04 from "@/public/static/images/sa-04.png";

import Sa05 from "@/public/static/images/sa-05.png";
import Sa06 from "@/public/static/images/sa-06.png";
import Sa07 from "@/public/static/images/sa-07.png";
import Sa08 from "@/public/static/images/sa-08.png";

import Sp01 from "@/public/static/images/sa-p-01.png";
import Sp02 from "@/public/static/images/sa-p-02.png";
import Sp03 from "@/public/static/images/sa-p-03.png";
import Sp04 from "@/public/static/images/sa-p-04.png";

import Sp05 from "@/public/static/images/sa-p-05.png";
import Sp06 from "@/public/static/images/sa-p-06.png";
import Sp07 from "@/public/static/images/sa-p-07.png";
import Sp08 from "@/public/static/images/sa-p-08.png";

import Sp09 from "@/public/static/images/sa-p-09.png";
import Sp10 from "@/public/static/images/sa-p-10.png";
import Sp11 from "@/public/static/images/sa-p-11.png";
import Sp12 from "@/public/static/images/sa-p-12.png";

import Sp13 from "@/public/static/images/sa-p-13.png";
import Sp14 from "@/public/static/images/sa-p-14.png";
import Sp15 from "@/public/static/images/sa-p-15.png";
import Sp16 from "@/public/static/images/sa-p-16.png";

import Sp17 from "@/public/static/images/sa-p-17.png";
import Sp18 from "@/public/static/images/sa-p-18.png";
import Sp19 from "@/public/static/images/sa-p-19.png";
import Sp20 from "@/public/static/images/sa-p-20.png";

import Sp21 from "@/public/static/images/sa-p-21.png";
import Sp22 from "@/public/static/images/sa-p-22.png";

function sales_promotion_tools() {
  const img: any = "/static/images/s-sale.png";

  const imgAnimation = UseAnimation();

  const handleMouseMove = (e: any) => {
    const { clientX, clientY } = e;
    const moveX = clientX - window.innerWidth / 2;
    const moveY = clientY - window.innerHeight / 2;
    const offsetFactor = 15;
    imgAnimation.start({
      x: moveX / offsetFactor,
      y: moveY / offsetFactor,
    });
  };

  return (
    <div className="wrapper">
      <Header />

      <section className="key_visual">
        <motion.img
          // animate={imgAnimation}
          // onMouseMove={(e) => handleMouseMove(e)}
          src={img}
          alt="Event Activation"
          loading="lazy"
        />
        <div className="img-bg" />
      </section>

      <section className="sv_content dmkt-content">
        <div className="container">
          <div className="row">
            <div className="col-12 heading-top_content">
              <div className="d-flex justify-content-center">
                <h2>Sales Promotion Tools</h2>
              </div>
            </div>
            <div className="col-12 sv_content-inner">
              <p className="mb-4">
                By fully employing its global network and establishing a
                procurement network, ITP Asia assembles ideas for various Sales
                Promotion Tools.
              </p>
              <p className="mb-4">
                More than 10,000 products have been delivered to promote and
                support our client’s services and sales, such as novelties given
                at events, gifts with corporate logos distributed during the
                year-end and New Year holidays, car wrapping for displaying
                logos of the company around town, POPs set up at stores to
                compete with other brands and trophies used in competitions.
              </p>
              <ul className="mb-5">
                <li>Stationery (pens, rulers, notebooks, etc.)</li>
                <li>
                  Electrical products (mobile batteries, wireless speakers,
                  smart watches, etc.)
                </li>
                <li>Car wrapping</li>
                <li>
                  POP (standees, beach flags, acrylic stands, backdrops, etc.)
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="sv_content black-content">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center ev-heading-spr_bl">
              <h1 className="fw-bolder t-blue lh-1">
                Let your brand stand out, be aware,
                <br />
                and build a relationship with your potentials
              </h1>
              <h2 className="t-white">
                by our Sales Promotion Tools with our fullest support
              </h2>
            </div>
          </div>
        </div>
      </section>

      <section className="sv_content gray-content">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center ev-heading-spr_bl">
              <h2 className="mb-0">
                Have no idea why Sales Promotion Tools matters?
              </h2>
              <h2 className="t-darkblue fw-bolder">
                Here are some guides how Sales Promotion Tools impact your
                business
              </h2>
            </div>
          </div>
        </div>
        <div className="container-fluid">
          <div className="row d-flex align-items-center">
            <div className="col-12 col-md-12 heading-sale p-0 pt-3 d-flex align-items-center">
              <div className="d-inline-block me-4">
                <Image
                  loading="lazy"
                  src={Sa01}
                  alt=""
                  width={300}
                  className="img-fluid mx-auto"
                />
              </div>
              <div className="d-inline-block">
                <h1 className="mb-0">
                  <span className="t-darkblue fw-bolder">Advertising</span>{" "}
                  <span className="t-darkblue">your brand</span>
                </h1>
                <h2 className="lh-1 mb-0">
                  for brand awareness, recognition,
                  <br /> and information providing
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row justify-content-end">
            <div className="col-12 col-md-6 text-left ev-heading-spr_bl">
              <div className="d-flex align-items-center">
                <ul className="sale-ul">
                  <li>
                    <span className="fw-bolder t-darkblue">Car Wrapping</span>
                  </li>
                  <li>
                    <span className="fw-bolder t-darkblue">POPs:</span>{" "}
                    Standees, Flags, Backdrops, X-Stand etc.
                  </li>
                  <li>
                    <span className="fw-bolder t-darkblue">Novelties </span>
                    for events or exhibitions
                  </li>
                  <li>
                    <span className="fw-bolder t-darkblue">
                      Booth design & set up{" "}
                    </span>
                    for events or exhibitions
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="row row-cols-1 row-cols-md-2 row-cols-lg-4  g-4 mt-3">
            <div className="col sale-box">
              <div className="card h-100">
                <Image
                  loading="lazy"
                  src={Sp01}
                  alt="Booth"
                  className="img-fluid mx-auto"
                />
              </div>
            </div>
            <div className="col sale-box">
              <div className="card h-100">
                <Image
                  loading="lazy"
                  src={Sp02}
                  alt="X-Stand"
                  className="img-fluid mx-auto"
                />
              </div>
            </div>
            <div className="col sale-box">
              <div className="card h-100">
                <Image
                  loading="lazy"
                  src={Sp03}
                  alt="Standee"
                  className="img-fluid mx-auto"
                />
              </div>
            </div>
            <div className="col sale-box">
              <div className="card h-100">
                <Image
                  loading="lazy"
                  src={Sp04}
                  alt="Flag"
                  className="img-fluid mx-auto"
                />
              </div>
            </div>
            <div className="col sale-box">
              <div className="card h-100">
                <Image
                  loading="lazy"
                  src={Sp05}
                  alt="Car Wrapping"
                  className="img-fluid mx-auto"
                />
              </div>
            </div>
            <div className="col sale-box">
              <div className="card h-100">
                <Image
                  loading="lazy"
                  src={Sp06}
                  alt="Digital Signage"
                  className="img-fluid mx-auto"
                />
              </div>
            </div>
            <div className="col sale-box">
              <div className="card h-100">
                <Image
                  loading="lazy"
                  src={Sp07}
                  alt="Backdrop"
                  className="img-fluid mx-auto"
                />
              </div>
            </div>
            <div className="col sale-box">
              <div className="card h-100">
                <Image
                  loading="lazy"
                  src={Sp08}
                  alt="Pop"
                  className="img-fluid mx-auto"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="sv_content black-content">
        <div className="container-fluid">
          <div className="row d-flex align-items-center">
            <div className="col-12 col-md-12 heading-sale p-0 pt-3 d-flex align-items-center">
              <div className="d-inline-block me-4">
                <Image
                  loading="lazy"
                  src={Sa02}
                  alt=""
                  width={300}
                  className="img-fluid mx-auto"
                />
              </div>
              <div className="d-inline-block">
                <h1 className="mb-0">
                  <span className="t-blue">Build a</span>{" "}
                  <span className="t-blue fw-bolder">Good Relationship</span>
                </h1>
                <h2 className="lh-1 mb-0 t-white">
                  with your value clients and employees
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row justify-content-end">
            <div className="col-12 col-md-6 text-left ev-heading-spr_bl">
              <div className="d-flex align-items-center">
                <ul className="sale-ul-lightbule t-white">
                  <li>
                    <span className="fw-bolder t-blue">Gifts </span> in special
                    occasion: Calendars, Mugs
                  </li>
                  <li>
                    <span className="fw-bolder t-blue">Stationery: </span> Pen,
                    Note Pads, Notebooks, etc.
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="row row-cols-1 row-cols-md-2 row-cols-lg-4  g-4 mt-3">
            <div className="col sale-box">
              <div className="card h-100">
                <Image
                  loading="lazy"
                  src={Sp09}
                  alt="Trophy"
                  className="img-fluid mx-auto"
                />
              </div>
            </div>
            <div className="col sale-box">
              <div className="card h-100">
                <Image
                  loading="lazy"
                  src={Sp10}
                  alt="Calendar"
                  className="img-fluid mx-auto"
                />
              </div>
            </div>
            <div className="col sale-box">
              <div className="card h-100">
                <Image
                  loading="lazy"
                  src={Sp11}
                  alt="Mug"
                  className="img-fluid mx-auto"
                />
              </div>
            </div>
            <div className="col sale-box">
              <div className="card h-100">
                <Image
                  loading="lazy"
                  src={Sp12}
                  alt="Pen"
                  className="img-fluid mx-auto"
                />
              </div>
            </div>
            <div className="col sale-box">
              <div className="card h-100">
                <Image
                  loading="lazy"
                  src={Sp13}
                  alt="Mask"
                  className="img-fluid mx-auto"
                />
              </div>
            </div>
            <div className="col sale-box">
              <div className="card h-100">
                <Image
                  loading="lazy"
                  src={Sp14}
                  alt="Paper bag"
                  className="img-fluid mx-auto"
                />
              </div>
            </div>
            <div className="col sale-box">
              <div className="card h-100">
                <Image
                  loading="lazy"
                  src={Sp15}
                  alt="Notebook"
                  className="img-fluid mx-auto"
                />
              </div>
            </div>
            <div className="col sale-box">
              <div className="card h-100">
                <Image
                  loading="lazy"
                  src={Sp16}
                  alt="Note Pad"
                  className="img-fluid mx-auto"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="sv_content gray-content">
        <div className="container-fluid">
          <div className="row d-flex align-items-center">
            <div className="col-12 col-md-12 heading-sale p-0 pt-3 d-flex align-items-center">
              <div className="d-inline-block me-4">
                <Image
                  loading="lazy"
                  src={Sa03}
                  alt=""
                  width={300}
                  className="img-fluid mx-auto"
                />
              </div>
              <div className="d-inline-block">
                <h1 className="mb-0">
                  <span className="t-darkblue">Add</span>{" "}
                  <span className="t-darkblue fw-bolder">values </span>{" "}
                  <span className="t-darkblue">to your brand</span>
                </h1>
                <h2 className="lh-1 mb-0">
                  make your brand stand out with <br />
                  premium goods
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row justify-content-end">
            <div className="col-12 col-md-6 text-left ev-heading-spr_bl">
              <div className="d-flex align-items-center">
                <ul className="sale-ul">
                  <li>
                    <span className="fw-bolder t-darkblue">
                      Electrical Products:
                    </span>{" "}
                    Mobile Batteries, Wireless Speakers, Smart Watches, etc.
                  </li>
                  <li>Customized Goods and Packages</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="row row-cols-1 row-cols-md-2 row-cols-lg-4  g-4 mt-3">
            <div className="col sale-box">
              <div className="card h-100">
                <Image
                  loading="lazy"
                  src={Sp17}
                  alt="Umbrella"
                  className="img-fluid mx-auto"
                />
              </div>
            </div>
            <div className="col sale-box">
              <div className="card h-100">
                <Image
                  loading="lazy"
                  src={Sp18}
                  alt="Golf ball"
                  className="img-fluid mx-auto"
                />
              </div>
            </div>
            <div className="col sale-box">
              <div className="card h-100">
                <Image
                  loading="lazy"
                  src={Sp19}
                  alt="Gift set"
                  className="img-fluid mx-auto"
                />
              </div>
            </div>
            <div className="col sale-box">
              <div className="card h-100">
                <Image
                  loading="lazy"
                  src={Sp20}
                  alt="Cap"
                  className="img-fluid mx-auto"
                />
              </div>
            </div>
            <div className="col sale-box">
              <div className="card h-100">
                <Image
                  loading="lazy"
                  src={Sp21}
                  alt="Flask"
                  className="img-fluid mx-auto"
                />
              </div>
            </div>
            <div className="col sale-box">
              <div className="card h-100">
                <Image
                  loading="lazy"
                  src={Sp22}
                  alt="Bag"
                  className="img-fluid mx-auto"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="sv_content black-content">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center ev-heading-spr_bl">
              <h1 className="fw-bolder t-blue lh-1">Why with us?</h1>
              <h2 className="t-white mb-0">
                With more than 10,000 products we delivered to promote and
                support our client’s services and sales,
              </h2>
              <h2 className="fw-bolder t-blue">
                Here are what we offer you with heart
              </h2>
            </div>
          </div>

          <div className="row justify-content-md-center mt-5">
            <div className="col-12 col-md-4 card-sv card-event">
              <div className="card h-100 text-center t-white">
                <Image
                  loading="lazy"
                  src={Sa04}
                  alt="Best ideas, Best Solutions"
                  className="img-fluid mx-auto w-25"
                />
                <div className="card-body">
                  <h2 className="mb-0 lh-1">Best ideas,</h2>
                  <h2 className="card-title t-blue fw-bolder mb-4">
                    Best Solutions
                  </h2>
                  <p>
                    With our long time of experience in producing Sales
                    Promotion Tools, We can provide you the best ideas and
                    solutions that meet your objectives and goals.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 card-sv card-event">
              <div className="card h-100 text-center t-white">
                <Image
                  loading="lazy"
                  src={Sa05}
                  alt="Anything you can think of"
                  className="img-fluid mx-auto w-50"
                />
                <div className="card-body">
                  <h2 className="card-title t-blue fw-bolder mb-0 ">
                    Anything
                  </h2>
                  <h2 className="lh-1 mb-4">you can think of</h2>

                  <p>
                    No matter what kind of stuffs you have in your mind, we
                    support you with our experienced marketing team and strong
                    joint venture with many global network that will make your
                    ideas be real.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 card-sv card-event">
              <div className="card h-100 text-center t-white">
                <Image
                  loading="lazy"
                  src={Sa06}
                  alt="Unbelievably Easy!"
                  className="img-fluid mx-auto w-25"
                />
                <div className="card-body">
                  <h2 className="mb-0 lh-1">Unbelievably</h2>
                  <h2 className="card-title t-blue fw-bolder mb-4">Easy!</h2>
                  <p>
                    From start to success: we work closely with you in every
                    single step of the plan. All you have to do is just let us
                    know what you need, then we execute!
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12 text-center ev-heading-spr_bl my-4">
              <h2 className="t-white mb-3">
                As a response to your Sales Promotion problems,
                <br />
                at ITP Asia, we pay attention to every single detail of the
                plan.
              </h2>
              <h2 className="t-blue">
                No matter what purpose of your Sales Promotional Plan is,
                <br />
                we take it serious like ours.
              </h2>
            </div>
          </div>
        </div>
      </section>

      <section className="black-content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-lg-6 box-half-sale d-flex justify-content-start align-items-center">
              <div className="row justify-content-start align-items-center">
                <div className="col-12 mb-2">
                  <div className="d-flex justify-content-start align-items-center h-100">
                    <Image
                      loading="lazy"
                      src={Sa08}
                      alt="Empathize your situation"
                      className="icon"
                    />
                    <h1 className="mb-0">Empathize your situation</h1>
                  </div>
                </div>
                <div className="col-12 mb-2">
                  <div className="d-flex justify-content-start align-items-center h-100">
                    <Image
                      loading="lazy"
                      src={Sa08}
                      alt="Plan strategically"
                      className="icon"
                    />
                    <h1 className="mb-0">Plan strategically</h1>
                  </div>
                </div>
                <div className="col-12 mb-2">
                  <div className="d-flex justify-content-start align-items-center h-100">
                    <Image
                      loading="lazy"
                      src={Sa08}
                      alt="Provide solutions"
                      className="icon"
                    />
                    <h1 className="mb-0">Provide solutions</h1>
                  </div>
                </div>
                <div className="col-12 mb-2">
                  <div className="d-flex justify-content-start align-items-center h-100">
                    <Image
                      loading="lazy"
                      src={Sa08}
                      alt="Execute with confidence"
                      className="icon"
                    />
                    <h1 className="mb-0">Execute with confidence</h1>
                  </div>
                </div>
                <div className="col-12 mb-2">
                  <div className="d-flex justify-content-start align-items-center h-100">
                    <Image
                      loading="lazy"
                      src={Sa08}
                      alt="Ensure a pleasant outcome"
                      className="icon"
                    />
                    <h1 className="mb-0">Ensure a pleasant outcome</h1>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-6 px-5">
              <Image
                loading="lazy"
                src={Sa07}
                alt="Let us execute your 
                  printing project,
                  Because we have it 
                  all set for you!"
                className="img-fluid mx-auto p-5"
              />
            </div>
          </div>
        </div>
      </section>
      <section className="sv_content black-content">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center ev-heading-spr_bl">
              <h2 className="t-blue">
                Let us be a part of your Sales Promotional Plan success,
                <br />
                Drop us your contact! We can’t wait to reach you!
              </h2>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default sales_promotion_tools;
